import React from "react";

function UserLogo() {
  return (
    <span className="iiht-svg">
      <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38">
        <path
          id="iconfont-checkcircle"
          d="M19,38A19,19,0,1,1,38,19,19.022,19.022,0,0,1,19,38ZM8.319,21.316a1.19,1.19,0,0,0-.842,2.03l5.9,5.635a1.19,1.19,0,0,0,1.682,0L30.487,13.964A1.191,1.191,0,0,0,28.8,12.28L14.216,26.459,9.161,21.665A1.186,1.186,0,0,0,8.319,21.316Z"
          fill="#4caf50"
        />
      </svg>
    </span>
  );
}

export default UserLogo;
